module.exports = __webpack_public_path__ + "fonts/bariol-bold.8b18d897.eot";